import { generateUrlWithQueryParams } from "../utils/url";

export const sendMessageToChat = async (
  question,
  historyMessages,
  filters
) => {
  const chatsApiUrl =
    process.env.REACT_APP_CHATS_API_URL ||
    "https://chat-dev.aiiro.ai/api/v2/aiirox";

  if (!chatsApiUrl) throw new Error("Not defined env file."); // should not be invoked

  const body = JSON.stringify({
    user_query: question,
    history:
      !!historyMessages && historyMessages.length > 0 ? historyMessages : [],
    company_names: filters?.companyNames,
    countries: filters?.companyCountries,
    sectors: filters?.sectors,
  });

  // const jwtToken = await JWTToken();

  const response = await fetch(
    generateUrlWithQueryParams(`${chatsApiUrl}/chat-stream`),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${jwtToken}`
      },
      body,
    }
  );

  if (!response.body) throw new Error("Response body is missing");

  const reader = response.body.getReader();
  const decoder = new TextDecoder();

  let isFirstChunk = true;
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  return new ReadableStream({
    start(controller) {
      const processText = async (result) => {
        const { done, value } = result;

        if (done) {
          controller.close();
          return;
        }

        const decodedText = decoder.decode(value, { stream: true });
        // controller.enqueue(decodedText);

        // Split the decoded text into smaller chunks
        const chunkSize = 12; // Define your smaller chunk size here
        let position = 0;

        if (isFirstChunk) {
          // Optional: Delay for the first chunk
          await delay(50); // Larger delay for the first chunk
          isFirstChunk = false;
        }

        while (position < decodedText.length) {
          const chunk = decodedText.slice(position, position + chunkSize);
          controller.enqueue(chunk);
          position += chunkSize;

          // Optional: Delay between chunks for smoother streaming
          await delay(100); // Adjust the delay between chunk enqueues
        }

        if (!response.ok) {
          throw new Error();
        }

        return reader.read().then(processText);
      };

      reader
        .read()
        .then(processText)
        .catch((err) => controller.error(err));
    },
  });
};
